import { render } from "./HormoneReplacementContentEs.vue?vue&type=template&id=07a2ba94&scoped=true"
import script from "./HormoneReplacementContentEs.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContentEs.vue?vue&type=script&lang=js"

import "./HormoneReplacementContentEs.vue?vue&type=style&index=0&id=07a2ba94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a2ba94"]])

export default __exports__